import React, { Component, useDebugValue } from "react";
import {withRouter} from 'react-router-dom';
import { connect } from 'react-redux';
import moment from "moment";
import { Form, FormGroup, FormFeedback, Col, Label, Input, Button, 
          Row, CustomInput, Popover, PopoverHeader, PopoverBody,
          Dropdown, DropdownItem, DropdownToggle, DropdownMenu,
          Modal, ModalBody, ModalHeader, Table
        } from "reactstrap";
import Tooltip from '../../../../components/UI/TooltipIcon/TooptipIcon';
import Toggle from "react-toggle";
import "react-toggle/style.css";
import Select from "react-select";
import Loading from '../../../../hoc/Loading/Loading';
import axios from '../../../../axios';
import * as actionCreators from '../../../../modules/actions/index';
import * as url from '../../../../utils/url';
// privacyLabel
import {privacyLabel, newDashboard} from '../../../../utils/constants';

// import Dropdown from '../../Reusable/Dropdown'
import DatePicker from 'react-datepicker';


class CreateDboard extends Component {
  createUserInputRef = React.createRef();
  createUserTableRef  = React.createRef();

  constructor(props) {
    super(props);
    this.state = {
      ...newDashboard,
      isArchiveModal:this.props.isArchiveModal,
      preventCreate:false,
      isComplete:false
    };
    this.timer = null;

  }

  
  closeActionsModal=()=>{
    this.setState({...newDashboard})
    this.props.closeActionsModal()
  }

 
  archiveDashboard=()=>{
      this.setState({preventCreate:true})
      let that=this
      axios.post(url.archiveDashboard, {_id: this.props.currentDashboard._id}).then((response) => {
          that.setState({preventCreate:false, isComplete:true})
          let url =`/home/dashboard-list/${that.props.user.profile.organizationId._id}`
          that.props.newDashboardUrl(url)         
      }).catch((error) => { console.log(error) });
  }





  render() {
    let { preventCreate , isComplete} = this.state;
    let {isArchiveModal, currentDashboard} = this.props

    return (
      <span className="dashboardSettingsContainer">
      
        <Modal isOpen={isArchiveModal} className="dashboardArchiveModalContainer createModalContainer">
        <ModalHeader className="dashboardHeader" 
        // charCode="X"
        //   toggle={()=>this.closeActionsModal()}
          >
          <div className="dashboardModalTitle">Archive the dashboard 
          <div>"{currentDashboard.name}"?</div></div>
        </ModalHeader>
              <ModalBody className="dashboardModalBody archiveDashboardModalContent">
              
             {isComplete?
             <span>Your dashboard has been removed.</span>
             :
             
             <span>
              You're about to delete this dashboard. This action can't be undone.

                  <div className="submitPrivacyContainer archiveBtnContainer"
                  style={{ padding: '10px 0px 0px 0px' }}>
                      <Button className={`archiveDashboardModalBtn ${preventCreate?'disabledBtn':''}`} onClick={!preventCreate?()=>this.archiveDashboard():null} >
                        <span className="">
                        Delete dashboard
                        <span className="ml10 flaticon-trash"></span></span>
                      </Button>

                      <Button outline color='secondary' className="cancelDashboardModalBtn" onClick={()=>this.closeActionsModal()}>
                        <span className="">Cancel</span>
                      </Button>
                  </div>
                  </span>
                  }
                </ModalBody>
        </Modal>
      </span>
    );
  }
}


const mapStateToProps = state => {
  return {
    user: state.user,
    kpiMaster: state.kpiMaster,
    mappingMaster: state.mappingMaster
  }
}

const mapDispatchToProps = dispatch => {
  return {
    onKpiMasterListFetched: (data) => dispatch(actionCreators.storeKpiMaster(data)),
    onMappingMasterListFetched: (data) => dispatch(actionCreators.storeMappingMaster(data)),
    onProfileUpdate: (data) => dispatch(actionCreators.updateProfileInfoSuccess(data)),
    updateNavBar: (header) => dispatch(actionCreators.navBarUpdate(header))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Loading(CreateDboard, axios)));

